<template>
  <!--所有页面的底部5大导航tab-->
  <van-tabbar v-model="active" @change="onChange" active-color="#000" inactive-color="#000" id="tabbar">
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>智能客服</span>
      <template #icon="props">
        <img :src="props.active ? serviceIcon.active : serviceIcon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>扫一扫</span>
      <template #icon="props">
        <img :src="props.active ? carIcon.active : carIcon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>商家</span>
      <template #icon="props">
        <img :src="props.active ? woIcon.active : woIcon.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'businessTabBar',
  data () {
    return {
      appTheme:this.$store.state.appTheme,
      home: require('@/assets/'+ this.$store.state.appTheme +'/tab_home_active.png'),
      icon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_home_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_home.png'),
      },
      woIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/b_shop1.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/b_shop2.png'),
      },
      orderIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_order_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_order.png'),
      },
      carIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/b_sao1.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/b_sao2.png'),
      },
      serviceIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_service_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_service.png'),
      }
    }
  },
  computed: {
    active: {
      get () {
        // 获取当前路由的路径,主要用于选中哪一个tabbar
        const path = this.$route.path
        console.log(path)
        switch (path) {
          case '/indexBusiness':
            return 0
          case '/service':
            return 1
          case '/scanBusiness':
            return 2
          case '/userBusiness':
            return 3
          default:
            return -1
        }
      },
      set () {
      }
    }
  },
  methods: {
    // tabbar改变切换页面
    onChange (index) {
      switch (index) {
        case 0:
          this.$router.replace('/indexBusiness')
          break
        case 1:
          this.$router.replace('/service')
          break
        case 2:
          this.$router.replace('/scanBusiness')
          break
        case 3:
          this.$router.replace('/userBusiness')
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
